import React from 'react';

import { Img } from "@randajan/jet-react/dom/img";

import "./Medailon.scss";
import { icons } from '../icons';

export const Medailon = (props)=>{
    const { name, email, grant, img, onClick } = props;

    return (
        <div className="Medailon" title={`${name}\n${grant}\n${email}`} onClick={onClick}>
            <Img className="main"  src={img}/>
            <Img className="grant" src={icons[grant]} noFetch/>
        </div>
        
    )
}

